import React, { useRef, useEffect } from 'react'
import injectStyles from 'react-jss'
import { authorization } from 'Module/Auth/Auth'
import GenericFlatButton from '../../GenericFlatButton'
import CloseIcon from 'Assets/Images/icons/modalClose'
import { styles } from '../ActionModals/styles'

const GermanyPayrollModal = ({ germanyPayrollData, onClose, classes }) => {
  const ModalItem = ({ label, value }) => {
    return (
      <div className={classes.germanyPayrollItemWrapper}>
        <div className={classes.itemTitle}>{label}</div>
        <div className={classes.itemValue}>{value}</div>
      </div>
    )
  }

  const isCityManagerAssistant = authorization.isCityManagerAssistant()

  const modalRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = event => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose()
      }
    }

    const handleEscapeKeyPress = event => {
      if (event.key === 'Escape') {
        onClose()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('keydown', handleEscapeKeyPress)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', handleEscapeKeyPress)
    }
  }, [onClose])

  return (
    <div className={classes.modalContainer} ref={modalRef}>
      <div className={classes.nmbrsModalTitle}>German Payroll Data</div>
      <span className={classes.close} onClick={onClose}>
        <CloseIcon />
      </span>
      <div className={classes.modalDataWrapper}>
        <div className={classes.modalRow}>
          {germanyPayrollData.taxId ? (
            <React.Fragment>
              <ModalItem
                label={'Tax ID'}
                value={germanyPayrollData.taxId || '-'}
              />
              <ModalItem
                label={'Tax Class'}
                value={germanyPayrollData.taxClass || '-'}
              />
              <ModalItem
                label={'Number of children'}
                value={germanyPayrollData.children || '--'}
              />
            </React.Fragment>
          ) : (
            <ModalItem label={'Tax ID'} value="No Tax ID" />
          )}
        </div>
        <div className={classes.modalRow}>
          <ModalItem
            label={'Social Security Number'}
            value={germanyPayrollData.socialSecurity || '-'}
          />
          <ModalItem
            label={'Religion'}
            value={germanyPayrollData.religion || '-'}
          />
          <ModalItem
            label={'Middle name'}
            value={germanyPayrollData.middleName || '-'}
          />
        </div>
        <div className={classes.divider} />
        <div className={classes.modalRow}>
          <ModalItem
            label={'Type of Health Insurance'}
            value={germanyPayrollData.healthInsuranceType || '-'}
          />
          <ModalItem
            label={'Health Insurance Provider'}
            value={germanyPayrollData.healthInsurance || '-'}
          />
        </div>
        <div className={classes.divider} />
        <div className={classes.modalRow}>
          {!isCityManagerAssistant ? (
            <ModalItem
              label={'IBAN'}
              value={germanyPayrollData.bankIban || '-'}
            />
          ) : null}
          <ModalItem
            label={'SWIFT'}
            value={germanyPayrollData.bankSwift || '-'}
          />
        </div>
        <div className={classes.modalRow}>
          <ModalItem
            label={'City of birth'}
            value={germanyPayrollData.birthCity || '-'}
          />
          <ModalItem
            label={'Country of birth'}
            value={germanyPayrollData.birthCountry || '-'}
          />
          <ModalItem
            label={'Gender'}
            value={germanyPayrollData.gender || '-'}
          />
        </div>
      </div>
      <div className={classes.cancelButton}>
        <GenericFlatButton type={'outline'} title={'Close'} onClick={onClose} />
      </div>
    </div>
  )
}

export default injectStyles(styles)(GermanyPayrollModal)
